import { axiosInstance } from "@/config/axios";
import { objectToCamel } from "ts-case-convert";
import { z } from "zod";
import { ContractRequestOptions, mapToBackendContractRequest } from "@/utils";
import { generatedContractRequestSchema } from "@/types/schemas/contractRequest";
import { Contract } from "@/types/contract";

export const updateRequest = async (uuid: string, contractRequest: Contract, contractOptions?: ContractRequestOptions) => {
  const updatedRequest = mapToBackendContractRequest(uuid, contractRequest, {
    generateContractRequest: false,
    ...contractOptions,
  });
  const response = await axiosInstance.put(`/request/${uuid}`, updatedRequest);

  const parsedResponse = z.object({ contract: generatedContractRequestSchema }).safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error(parsedResponse.error.issues);
    throw new Error("zod error");
  }

  return {
    ...contractRequest,
    uuid,
    executivePeople: parsedResponse.data.contract.executivePeople,
    supplyPoint: parsedResponse.data.contract.supplyPoint,
  };
};

export const generateRequest = async (uuid: string, contractRequest: Contract, contractOptions?: ContractRequestOptions) => {
  const updatedContractRequest = mapToBackendContractRequest(uuid, contractRequest, {
    generateContractRequest: true,
    ...contractOptions,
  });
  const response = await axiosInstance.put(`/request/${uuid}`, updatedContractRequest);

  const parsedResponse = z.object({ contract: generatedContractRequestSchema }).safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error(parsedResponse.error.issues);
    throw new Error("zod error");
  }
  return parsedResponse.data.contract;
};
